import { FelaCSS } from '@bridebook/ui';

interface IStyleProps {
  isTablet: boolean;
}

interface IStyles {
  wrapper: FelaCSS;
}

const styles = ({ isTablet }: IStyleProps): IStyles => ({
  wrapper: {
    width: isTablet ? '100%' : '33%',

    maxWidthMobile: {
      width: '100%',
    },
  },
});

export default styles;
